import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import { loginInterception, publicPath } from "@/setting.config";
import { lazyLoadView } from "@/utils/commonTools";
import i18n from "@/lang/index.js";
Vue.use(VueRouter);

const routes = [
  {
    path: "/wechatCallback",
    name: "wechatCallback",
    component: () =>
      lazyLoadView(
        import("@/views/login/components/WechatCallback.vue"),
        require("@/components/layouts/LoadingCircle.vue").default
      ),
    meta: {
      title: i18n.t("login.login"),
      noLogin: true,
      hideMenu: true,
    },
  },
  {
    path: "/dingdingCallback",
    name: "dingdingCallback",
    component: () =>
      lazyLoadView(
        import("@/views/login/components/DingdingCallback.vue"),
        require("@/components/layouts/LoadingCircle.vue").default
      ),
    meta: {
      title: i18n.t("login.login"),
      noLogin: true,
      hideMenu: true,
    },
  },
  {
    path: "/",
    name: "index",
    component: () => import("@/components/layouts/MenuLayout.vue"),
    children: [
      {
        path: "/baseInfo/venueTypeSetting",
        name: "venueTypeSetting",
        component: () =>
          lazyLoadView(
            import("@/views/baseInfo/venueTypeSetting"),
            require("@/components/layouts/LoadingCircle.vue").default
          ),
        meta: {
          title: "场所类型设置",
        },
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: () =>
      lazyLoadView(
        import("@/views/login"),
        require("@/components/layouts/LoadingCircle.vue").default
      ),
    meta: {
      title: i18n.t("login.login"),
      noLogin: true,
      hideMenu: true,
    },
  },

  {
    path: "/mobile/login",
    name: "mobileLogin",
    component: () =>
      lazyLoadView(
        import("@/views/mobileLogin"),
        require("@/components/layouts/LoadingCircle.vue").default
      ),
    meta: {
      title: i18n.t("login.login"),
      noLogin: true,
      hideMenu: true,
    },
  },
  {
    path: "/404",
    name: "404",
    component: () => import("@/views/404"),
    meta: {
      title: "404",
      noLogin: true,
      hideMenu: true,
    },
  },
  {
    path: "/Home",
    name: "Home",
    component: () => import("@/views/index/main.vue"),
    meta: {
      title: i18n.t("menubar.home"),
      noLogin: true,
      hideMenu: false,
    },
  },
  {
    path: "/specializedServices",
    name: "specializedServices",
    component: () => import("@/views/index/components/specializedServices.vue"),
    meta: {
      title: "专题服务",
      noLogin: true,
      hideMenu: false,
    },
  },
  {
    path: "/myAffairs",
    name: "myAffairs",
    component: () => import("@/views/index/myAffairsNew.vue"),
    meta: {
      title: "myAffairsNew",
      noLogin: true,
      hideMenu: false,
    },
  },
  {
    path: "/search",
    name: "search",
    component: () => import("@/views/search/index.vue"),
    meta: {
      title: "搜索",
      noLogin: true,
      hideMenu: false,
      topCss: true,
    },
  },
  {
    path: "/transactionCenter",
    name: "transactionCenter",
    component: () => import("@/views/transactionCenter/transactionCenter.vue"),
    meta: {
      title: i18n.t("menubar.affairs"),
      noLogin: true,
      hideMenu: false,
      topCss: true,
    },
  },
  {
    path: "/effectiveness",
    name: "effectiveness",
    component: () => import("@/views/effectiveness/effectiveness.vue"),
    meta: {
      title: i18n.t("menubar.analysis"),
      noLogin: true,
      hideMenu: false,
      topCss: true,
    },
  },
  {
    path: "/guide",
    name: "guide",
    component: () => import("@/views/guide/index.vue"),
    meta: {
      title: i18n.t("menubar.service"),
      noLogin: true,
      hideMenu: false,
      topCss: true,
    },
    children: [
      {
        path: "",
        name: "guideList",
        component: () => import("@/views/guide/components/guide.vue"),
        meta: {
          title: i18n.t("menubar.service"),
          noLogin: true,
          hideMenu: false,
          topCss: true,
        },
      },
      {
        path: "detail/:id",
        name: "guideDetail",
        component: () => import("@/views/guide/components/guideDetail.vue"),
        meta: {
          title: "guide detail",
          noLogin: true,
          hideMenu: false,
          topCss: true,
        },
      },
    ],
  },
  {
    path: "/systems",
    name: "systems",
    component: () => import("@/views/systems/index.vue"),
    meta: {
      title: "systems",
      noLogin: true,
      hideMenu: false,
      topCss: true,
    },
  },
  {
    path: "/myAffairs",
    name: "myAffairs",
    component: () => import("@/views/myAffairs/index.vue"),
    meta: {
      title: "myAffairs",
      noLogin: true,
      hideMenu: false,
      topCss: false,
    },
    children: [
      {
        path: "",
        name: "myAffairsList",
        component: () => import("@/views/myAffairs/childCon/myAffairs.vue"),
        meta: {
          title: "myAffairs",
          noLogin: true,
          hideMenu: false,
          topCss: true,
        },
      },
      {
        path: "notice",
        name: "notice",
        component: () => import("@/views/myAffairs/childCon/notice.vue"),
        meta: {
          title: "notice",
          noLogin: true,
          hideMenu: false,
          topCss: true,
        },
      },
      {
        path: "noticeDetail",
        name: "noticeDetail",
        component: () => import("@/views/myAffairs/childCon/noticeDetail.vue"),
        meta: {
          title: "notice detail",
          noLogin: true,
          hideMenu: false,
          topCss: true,
        },
      },

      {
        path: "messageDetail",
        name: "messageDetail",
        component: () => import("@/views/myAffairs/childCon/messageDetail.vue"),
        meta: {
          title: "messageDetail",
          noLogin: true,
          hideMenu: false,
          topCss: true,
        },
      },
    ],
  },
  {
    path: "/message",
    name: "message",
    component: () => import("@/views/myAffairs/childCon/message.vue"),
    meta: {
      title: "message",
      noLogin: true,
      hideMenu: false,
      topCss: true,
    },
  },
  {
    path: "/thematicServices",
    name: "thematicServices",
    component: () => import("@/views/thematicServices/thematicServices.vue"),
    meta: {
      title: "thematicServices",
      noLogin: true,
      hideMenu: false,
      topCss: true,
    },
  },
  {
    path: "/accountActivation",
    name: "accountActivation",
    component: () => import("@/views/login/components/accountActivation.vue"),
    meta: {
      title: "账号激活",
      noLogin: true,
      hideMenu: true,
      topCss: true,
    },
  },

  // {
  //   path: "/news",
  //   name: "news",
  //   component: () => import("@/views/mobile/news.vue"),
  //   meta: {
  //     title: "新闻",
  //     noLogin: true,
  //     hideMenu: true,
  //     topCss: true,
  //   },
  // },
  // {
  //   path: "/serviceGuides",
  //   name: "serviceGuides",
  //   component: () => import("@/views/mobile/serviceGuides.vue"),
  //   meta: {
  //     title: "新闻",
  //     noLogin: true,
  //     hideMenu: true,
  //     topCss: true,
  //   },
  // },

  {
    path: "/confirm",
    name: "confirmWxLogin",
    component: () => import("@/views/mobile/confirmWxLogin.vue"),
    meta: {
      title: "confirmWxLogin",
      noLogin: true,
      hideMenu: true,
      topCss: true,
    },
  },
  {
    path: "/recommendServices",
    name: "recommendServices",
    component: () => import("@/views/recommendServices/recommendServices.vue"),
    meta: {
      title: "recommendServices",
      noLogin: true,
      hideMenu: false,
      topCss: true,
    },
  },
  {
    path: "/forgetPass",
    name: "forgetPass",
    component: () => import("@/views/login/components/forgetPass.vue"),
    meta: {
      title: "forgetPass",
      noLogin: true,
      hideMenu: true,
    },
  },
  {
    path: "/personalCenter",
    name: "personalCenter",
    component: () => import("@/components/personalCenter/personalCenter.vue"),
    meta: {
      title: "personalCenter",
      noLogin: true,
      hideMenu: false,
      topCss: true,
    },
  },

  {
    path: "/h5",
    name: "mobile-h5",
    component: () => import("@/views/mobile/h5.vue"),
    meta: {
      title: "h5",
      noLogin: true,
      hideMenu: false,
      topCss: true,
    },
    children: [
      {
        path: "login",
        name: "mobile-login",
        component: () => import("@/views/mobile/login"),
        meta: {
          title: i18n.t("login.login"),
          noLogin: true,
          hideMenu: true,
        },
      },
      {
        path: "dingtalk-auth",
        name: "mobile-dingtalk-auth",
        component: () => import("@/views/mobile/dingtalkAuth.vue"),
        meta: {
          title: "钉钉登录",
          noLogin: true,
          hideMenu: true,
          topCss: true,
        },
      },
      {
        path: "Home",
        name: "mobile-index",
        component: () => import("@/views/mobile/index.vue"),
        meta: {
          title: "主页",
          noLogin: true,
          hideMenu: false,
          topCss: true,
        },
      },
      {
        path: "systems",
        name: "mobile-apps",
        component: () => import("@/views/mobile/apps.vue"),
        meta: {
          title: "应用",
          noLogin: true,
          hideMenu: false,
          topCss: true,
        },
      },
      {
        path: "messages",
        name: "mobile-message",
        component: () => import("@/views/mobile/message.vue"),
        meta: {
          title: "消息",
          noLogin: true,
          hideMenu: false,
          topCss: true,
        },
      },
      {
        path: "messagesDetail/:id",
        name: "mobile-message-detail",
        component: () => import("@/views/mobile/messageDetail.vue"),
        meta: {
          title: "消息详情",
          noLogin: true,
          hideMenu: true,
          topCss: true,
        },
      },
      {
        path: "mine",
        name: "mobile-mine",
        component: () => import("@/views/mobile/mine.vue"),
        meta: {
          title: "我的",
          noLogin: true,
          hideMenu: false,
          topCss: true,
        },
      },
      {
        path: "infomations",
        name: "mobile-informations",
        component: () => import("@/views/mobile/infomations.vue"),
        meta: {
          title: "信息公告",
          noLogin: true,
          hideMenu: true,
          topCss: true,
        },
      },
      {
        path: "account",
        name: "mobile-account",
        component: () => import("@/views/mobile/account.vue"),
        meta: {
          title: "切换账户",
          noLogin: true,
          hideMenu: true,
          topCss: true,
        },
      },
      {
        path: "collection",
        name: "mobile-collection",
        component: () => import("@/views/mobile/collection.vue"),
        meta: {
          title: "收藏应用",
          noLogin: true,
          hideMenu: true,
          topCss: true,
        },
      },
      {
        path: "profile",
        name: "mobile-profile",
        component: () => import("@/views/mobile/profile.vue"),
        meta: {
          title: "个人中心",
          noLogin: true,
          hideMenu: true,
          topCss: true,
        },
      },
      {
        path: "bindPhone",
        name: "mobile-bindPhone",
        component: () => import("@/views/mobile/bindPhone.vue"),
        meta: {
          title: "绑定邮箱",
          noLogin: true,
          hideMenu: true,
          topCss: true,
        },
      },
      {
        path: "trustDevice",
        name: "mobile-trustDevice",
        component: () => import("@/views/mobile/trustDevice.vue"),
        meta: {
          title: "信任/FIDO设备",
          noLogin: true,
          hideMenu: true,
          topCss: true,
        },
      },
      {
        path: "subscription",
        name: "mobile-subscription",
        component: () => import("@/views/mobile/subscribe.vue"),
        meta: {
          title: "信任/FIDO设备",
          noLogin: true,
          hideMenu: true,
          topCss: true,
        },
      },
      {
        path: "changePassword",
        name: "mobile-changePassword",
        component: () => import("@/views/mobile/changePassword.vue"),
        meta: {
          title: "修改密码",
          noLogin: true,
          hideMenu: true,
          topCss: true,
        },
      },
      {
        path: "setting",
        name: "mobile-setting",
        component: () => import("@/views/mobile/setting.vue"),
        meta: {
          title: "设置中心",
          noLogin: true,
          hideMenu: true,
          topCss: true,
        },
      },
      {
        path: "loginLog",
        name: "mobile-loginLog",
        component: () => import("@/views/mobile/loginLog.vue"),
        meta: {
          title: "登录日志",
          noLogin: true,
          hideMenu: true,
          topCss: true,
        },
      },
      {
        path: "appLog",
        name: "mobile-appLog",
        component: () => import("@/views/mobile/appAccessLog.vue"),
        meta: {
          title: "应用访问记录",
          noLogin: true,
          hideMenu: true,
          topCss: true,
        },
      },
      {
        path: "operLog/:type",
        name: "mobile-accountLog",
        component: () => import("@/views/mobile/accountLog.vue"),
        meta: {
          title: "账号维护记录",
          noLogin: true,
          hideMenu: true,
          topCss: true,
        },
      },
      {
        path: "security",
        name: "mobile-security",
        component: () => import("@/views/mobile/security.vue"),
        meta: {
          title: "密保设置",
          noLogin: true,
          hideMenu: true,
          topCss: true,
        },
      },
      {
        path: "addSecurity",
        name: "mobile-addSecurity",
        component: () => import("@/views/mobile/addSecurity.vue"),
        meta: {
          title: "新增密保",
          noLogin: true,
          hideMenu: true,
          topCss: true,
        },
      },
      {
        path: "bindEmail",
        name: "mobile-bindEmail",
        component: () => import("@/views/mobile/bindEmail.vue"),
        meta: {
          title: "绑定邮箱",
          noLogin: true,
          hideMenu: true,
          topCss: true,
        },
      },
      {
        path: "retrieve",
        name: "mobile-retrieve",
        component: () =>
          lazyLoadView(
            import("@/views/mobile/retrieve/index.vue"),
            require("@/components/layouts/LoadingCircle.vue").default
          ),
        meta: {
          title: i18n.t("login.retrieve"),
          noLogin: true,
          hideMenu: true,
        },
      },
      {
        path: "bind",
        name: "mobile-bind",
        component: () => import("@/views/mobile/bind.vue"),
        meta: {
          title: "账号绑定",
          noLogin: true,
          hideMenu: true,
          topCss: true,
        },
      },

      {
        path: "search/:type",
        name: "mobile-search",
        component: () => import("@/views/mobile/searchResult.vue"),
        meta: {
          title: "搜索",
          noLogin: true,
          hideMenu: true,
          topCss: true,
        },
      },
      {
        path: "guide/:app",
        name: "mobile-guide",
        component: () => import("@/views/mobile/serviceGuide.vue"),
        meta: {
          title: "新闻",
          noLogin: true,
          hideMenu: true,
          topCss: true,
        },
      },
    ],
  },
  {
    path: "/loginLoading",
    name: "mobile-loginLoading",
    component: () => import("@/views/mobile/loginLoading.vue"),
    meta: {
      title: "登录加载中",
      noLogin: true,
      hideMenu: true,
      topCss: true,
    },
  },
  {
    path: "*", // Vue2 通配符，匹配所有未定义路径
    redirect: "/404", // 重定向到已定义的404页面
    meta: {
      noLogin: true, // 404页面无需登录
      hideMenu: false,
    },
  },
];

const router = new VueRouter({
  base: publicPath,
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  const isMobile = store.getters["app/isMobileMode"];
  if ((to.name === "404" || to.path === "/404") && !isMobile) {
    next();
    return;
  }
  // 如果是移动设备，且访问的是移动主页，重定向到移动主页

  if (isMobile) {
    // if (!to?.name?.startsWith("mobile")) {
    //   next("/h5");
    //   return;
    // }
    if (to?.path === "/h5" || to?.path === "/h5/") {
      next("/h5/Home");
      return;
    }
    if (!to.name) {
      next("/h5/Home");
    } else if (!to?.name?.startsWith("mobile")) {
      next("/h5" + to.fullPath);
      return;
    }
  } else {
    const allowMobileRouteInDesktop = to?.name === "mobile-dingtalk-auth";
    if (to?.name?.startsWith("mobile") && !allowMobileRouteInDesktop) {
      next("/Home");
      return;
    }
    if (to?.name === "index" && to?.path === "/") {
      next("/Home");
      return;
    }
    const accountInfo = JSON.parse(localStorage.getItem("accountInfo"));
    // 说明已登录
    if (!accountInfo) {
      if (to?.path === "/myAffairs" || to?.path === "/personalCenter") {
        next("/Home");
        return;
      }
    }
  }
  next();
});

// router.beforeEach((to, from, next) => {
//   console.log("beforeEach", to);

//   // 新增移动端检测逻辑
//   const isMobile = false; //window.innerWidth <= 768;
//   // if (isMobile && !to.path.startsWith("/mobile")) {
//   //   // 排除登录页的特殊处理
//   //   if (to.name === "login") {
//   //     next("/mobile/login");
//   //   } else {
//   //     next("/mobile" + to.path);
//   //   }
//   //   return;
//   // }

//   const isLoggedIn = !!store.getters["user/accessToken"];
//   const token = to.query.token;
//   if (!isLoggedIn && token) {
//     store.commit("user/setAccessToken", token);
//   }

//   // 修改登录页重定向逻辑，排除移动端路径和登录页
//   if (
//     to.name === "login" &&
//     isLoggedIn &&
//     !to.path.startsWith("/mobile") &&
//     to.path !== "/mobile/login"
//   ) {
//     next("/Home");
//     return;
//   }

//   // 检查是否需要验证登录状态
//   if (!to.meta?.noLogin && !isLoggedIn) {
//     // 如果是已经处于移动端登录页，直接放行
//     if (to.path === "/mobile/login") {
//       next();
//       return;
//     }
//     // 如果需要验证且用户未登录，则重定向到登录页面
//     if (isMobile) {
//       next(`/mobile/login?redirect=${to.fullPath}`);
//     } else {
//       next(`/login?redirect=${to.fullPath}`);
//     }
//   } else {
//     // 否则，允许访问或继续到下一个导航守卫
//     next();
//   }
// });

router.beforeResolve(async (to, from, next) => {
  // console.log("beforeResolve");
  // const id = store.getters["user/id"];
  // if (!id && loginInterception && !to.meta.noLogin) {
  //   // id不存在，则获取用户信息
  //   await store.dispatch("user/loadUserInfo");
  // }
  // const routeIsLoaded = store.getters["authItems/isLoaded"];
  // const isLoggedIn = !!store.getters["user/accessToken"];
  // if (!routeIsLoaded && isLoggedIn) {
  //   // 加载路由
  //   await store.dispatch("authItems/loadAuthItems");
  //   const menuList = store.getters["authItems/menu"];
  //   menuList.forEach((menu) => {
  //     if (!menu.component) {
  //       return;
  //     }
  //     router.addRoute("index", {
  //       path: menu.url,
  //       name: menu.code,
  //       component: () => lazyLoadView(import(`@/views${menu.component}`)),
  //       meta: {
  //         title: menu.name,
  //         noLogin: false,
  //         affix: !!menu.home,
  //       },
  //     });
  //   });
  //   const home = store.getters["authItems/home"];
  //   router.getRoutes().find((route) => route.name === "index").redirect =
  //     home.url;
  //   router.addRoute({
  //     path: "*",
  //     redirect: "/404",
  //   });
  //   next({ ...to, replace: true });
  // }
  next();
});

export default router;
